export enum UserStatus {
  APPROVED = 'Approved',
  SUSPENDED = 'Suspended',
  PENDING = 'Pending Approval',
  NOT_APPROVED = 'Not Approved',
}
export default UserStatus;
